import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronUp } from 'lucide-react';
import {
  HERO_SECTION_ID,
  fieldTeamHomePath,
  isFieldTeamHomePath,
  scrollToFieldTeamSection,
} from './fieldTeamRoutes';

export const FieldTeamBackToTop: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 420);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  const goTop = () => {
    const home = fieldTeamHomePath(location.pathname);
    if (isFieldTeamHomePath(location.pathname) && location.hash) {
      navigate({ pathname: home, hash: '' }, { replace: true });
    }
    scrollToFieldTeamSection(HERO_SECTION_ID, 'smooth');
  };

  return (
    <button
      type="button"
      className="ftl-to-top"
      onClick={goTop}
      aria-label={t('ftl_back_to_top')}
    >
      <ChevronUp size={22} strokeWidth={2.4} />
      <span>{t('ftl_back_to_top')}</span>
    </button>
  );
};

export default FieldTeamBackToTop;
